import React from 'react';
import UpperBodyFashionCatalogueWorkflow from '../ecommerce-photoshoot/UpperBodyFashionCatalogueWorkflow';
import { YOGA_WEAR_CATALOGUE_CONFIG } from '../ecommerce-photoshoot/catalogueWorkflowConfigs';

const YogaWearPhotoshoot: React.FC = () => (
  <UpperBodyFashionCatalogueWorkflow
    config={YOGA_WEAR_CATALOGUE_CONFIG}
    onBackToWorkflows={() => window.history.back()}
  />
);

export default YogaWearPhotoshoot;
